import * as action from './action.js';
import reducer from './reducer.js';
import view from './view.js';

export {action, reducer, view};



// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_detail/index.js